var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-chart-page"},[_c('v-chart',{staticClass:"chart",style:('height:' + _vm.height),attrs:{"option":_vm.dataOption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }